
import { defineComponent } from "vue";

export default defineComponent({
  name: "AfterConfirmationAcceptanceScreen",
  props: {
    insuredPersonEmail: {type: String, required: true},
  }
});
